module.exports = __webpack_public_path__ + "img/Broken Clasp.360fcbf1.png";